
















import Vue, { PropType } from "vue";

import ModulesJson from "../../shared/ModulesJson";

export default Vue.extend({
  name: "MainTabbar",
  props: {
    items: Array as PropType<ModulesJson[]>,
    currentTab: String,
  },
  data() {
    return {
      tabbarItems: [] as ModulesJson[],
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.$emit("displayedMainTabbarItems", this.itemsToDisplay);
      this.$emit("activeMainTabbarItems", this.activeItems);
    },

    scrollHorizontal: function (e: any) {
      e.currentTarget.scrollLeft += e.deltaY;
    },
  },
  watch: {},
  computed: {
    itemsToDisplay: function (): ModulesJson[] {
      let itemsToDisplay = this.items.filter((item: any) => item.isDisplayed);

      return itemsToDisplay ? itemsToDisplay : [];
    },

    activeItems: function (): ModulesJson[] {
      let activeItems = this.itemsToDisplay.filter((i: ModulesJson) => !i.isDisabled);

      return activeItems ? activeItems : [];
    },
  },
});
